<template>
  <div class="host">
    <h3>Доступ запрещен</h3>
    <p>
      Извините, но у Вас нет доступа к данной странице
      <br />
      Вы можете вернуться
      <a class="vm-back-link" @click="back()">назад</a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.host {
  padding: 3rem;
}
h3 {
  color: #212121;
}
p {
  color: rgba(0, 0, 0, 0.6);
}
a.vm-back-link {
  cursor: pointer;
  color: #4a56d1;
  font-weight: 500;
}
</style>
